import React, { useState, useEffect } from 'react';
import {
  Button,
  Flex,
  Text,
  Switch,
  Box,
  Image,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  IconButton,
  Stack,
  Checkbox,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import InputController from 'components/Form/InputController';
import { BsUpload, BsXCircle } from 'react-icons/bs';
import { nanoid } from 'nanoid';
import { mappingOptionSelect } from 'utils/mapping';
import { useDropzone } from 'react-dropzone';
import isEmpty from 'lodash/isEmpty';
import Card from 'components/Card/Card';
import { uploadPhotoProduct } from 'services/product';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import { useQueryGetProducts } from 'services/product';
import { toast } from 'components/Toast';
import { SystemNotificationFormValidateCP } from 'utils/validation';
import { useCreateSystemNotificationSetting } from 'services/system-notification';
import { useUpdateSystemNotificationSetting } from 'services/system-notification';
import { uploadPhotoNotification, useQueryGetNotificationDetail, usechangePublishNotiMutation } from 'services/notification';
import { LevelMemberOption, MissionOption, ROOT_API, SystemNotiOptions, SystemNotiType } from 'constants/common';
import SelectController from 'components/Form/SelectController';
import queryString from 'query-string';
import { getListMember } from 'services/purchase-history';
import debounce from 'lodash/debounce';
import AsyncSelectController from 'components/Form/AsyncSelectController';

const InitMemberFilter = { pageSize: 50, pageIndex: 0, searchKeyword: '' };

export default function SystemNotificationForm() {
  const params = useParams();
  const { id } = params || {};
  const query = useLocation();
  const { _id } = queryString.parse(query.search);
  const history = useHistory();
  const updateSystemNotificationSetting = useUpdateSystemNotificationSetting();
  const [files, setFiles] = useState([]);
  const [error, setError] = useState({
    thumbnailFile: null,
  });
  const [memberOptions, setMemberOptions] = useState([]);
  const [memberFilter, setMemberFilter] = useState(InitMemberFilter);
  const [isMemberLoading, setIsMemberLoading] = useState(false);

  const [isDragEnter, setIsDragEnter] = useState(false);
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/*': [],
    },
    onDragEnter: () => {
      setIsDragEnter(true);
    },
    onDragLeave: () => {
      setIsDragEnter(false);
    },
    onDrop: acceptedFiles => {
      setIsDragEnter(false);
      setError({ thumbnailFile: null });
      setFiles([
        // ...files,
        ...acceptedFiles.map(file => ({
          id: nanoid(),
          preview: URL.createObjectURL(file),
          file,
        })),
      ]);
    },
  });

  const { data: notiDetail, refetch } = useQueryGetNotificationDetail(_id, {
    enabled: !!_id,
  });
  const createSystemNotificationSetting = useCreateSystemNotificationSetting();
  const changePublishNotiMutation = usechangePublishNotiMutation();
  // const { data: members } = useQueryGetListMember({ pageIndex: 0, pageSize: 10, searchKeyword: 'tuananhchanel888' });

  const { control, handleSubmit, reset } = useForm({
    resolver: yupResolver(SystemNotificationFormValidateCP),
    defaultValues: {
      content: '',
      title: '',
      type: '',
    },
  });

  useEffect(() => {
    const data = notiDetail?.data;

    if (!isEmpty(data)) {
      reset({
        title: data.title,
        content: data.content,
        type: SystemNotiOptions.find(item => item.value === data?.type),
        listMembers: data?.members?.map(item => {
          const memberExists = memberOptions?.find(member => member?.value === item);

          return memberExists;
        }),
      });
      setFiles(data?.avatar ? [data?.avatar] : []);
    }
  }, [notiDetail, memberOptions]);

  // useEffect(() => {
  //   setMemberOptions(mappingOptionSelect(members?.data, 'username'));
  // }, [members?.data]);

  useEffect(() => {
    fetchMemberData(InitMemberFilter);
  }, []);

  const onUploadPhoto = async () => {
    const formData = new FormData();

    const filesUpload = files?.filter(item => item.file);

    let pathFiles = [];

    if (!isEmpty(filesUpload)) {
      filesUpload.map(item => {
        formData.append('thumbnailFile', item.file);
      });
      const response = await uploadPhotoNotification(formData);

      pathFiles = response?.data;

      return pathFiles;
    }
    return null;
  };

  const onSubmit = async dataForm => {
    const photosPath = await onUploadPhoto();
    const newDataForm = {
      ...dataForm,
      type: dataForm.type.value,
    };

    if (photosPath) {
      newDataForm.thumbnail = photosPath;
    }

    if (_id) {
      updateSystemNotificationSetting.mutate(
        { ...newDataForm, listMembers: dataForm?.listMembers?.map(item => item?.value), notificationId: _id },
        {
          onSuccess: () => {
            toast.showMessageSuccess('Cập nhật thông báo thành công');
            history.push('/admin/system-notification');
          },
          onError: () => {
            toast.showMessageError('Cập nhật thông báo thành công thất bại');
          },
        }
      );
    } else {
      createSystemNotificationSetting.mutate(
        { ...newDataForm, listMembers: dataForm?.listMembers?.map(item => item?.value) },
        {
          onSuccess: () => {
            toast.showMessageSuccess('Tạo cài đặt thông báo thành công');
            history.push('/admin/system-notification');
          },
          onError: () => {
            toast.showMessageError('Tạo cài đặt thông báo thất bại');
          },
        }
      );
    }
  };

  const onRemove = index => {
    setFiles(prev => prev.filter((i, idX) => idX !== index));
  };

  const handleSwitchChange = noti => {
    changePublishNotiMutation.mutate(
      { notificationId: noti?._id },
      {
        onSuccess: () => {
          toast.showMessageSuccess('Đã thay đổi trạng thái xuất bản thông báo');
          refetch?.();
        },
        onError: () => {
          toast.showMessageError('Thay đổi trạng thái xuất bản thông báo thất bại');
        },
      }
    );
  };

  const fetchMemberData = async (params, isClear = false) => {
    setIsMemberLoading(true);

    const memberResponse = await getListMember(params);
    const memberOptions = mappingOptionSelect(memberResponse?.data, 'username');

    if (isClear) {
      setMemberOptions(memberOptions);
      setIsMemberLoading(false);
      return;
    }

    setMemberOptions(prevOptions => [...prevOptions, ...memberOptions]);
    setIsMemberLoading(false);
  };

  const loadOptions = async inputValue => {
    return new Promise(resolve => {
      onInputChange(inputValue, resolve);
    });
  };

  const onInputChange = debounce(async (inputValue, callback) => {
    const memberResponse = await getListMember({
      ...memberFilter,
      pageIndex: 0,
      searchKeyword: inputValue,
    });

    const memberOptions = mappingOptionSelect(memberResponse?.data, 'username');

    setMemberFilter(prevState => ({
      ...prevState,
      pageIndex: 0,
      searchKeyword: inputValue,
    }));
    callback(memberOptions);
    setMemberOptions(memberOptions);
  }, 400);

  const handleOnScrollBottom = async () => {
    const newParams = {
      ...memberFilter,
      pageIndex: memberFilter.pageIndex + 1,
    };

    setMemberFilter(newParams);
    await fetchMemberData(newParams);
  };

  return (
    <Flex direction="column" pt={{ base: '120px', md: '75px' }}>
      <Card overflowX={{ sm: 'scroll', xl: 'hidden' }} pb="0px" bg="white">
        <CardHeader p="6px 0px 22px 0px">
          <Flex alignItems="center" justifyContent="space-between">
            <Text fontSize="xl" fontWeight="bold">
              {`${_id ? 'Cập nhật' : 'Tạo'} thông báo`}
            </Text>
            {!!_id && (
              <Flex flexDirection="column" alignItems="center" gap={1}>
                <Text>Phát hành</Text>
                <Switch
                  size="md"
                  isDisabled={notiDetail?.data?.isPublished}
                  isChecked={notiDetail?.data?.isPublished}
                  onChange={() => handleSwitchChange(notiDetail?.data)}
                />
              </Flex>
            )}
          </Flex>
        </CardHeader>
        <CardBody pb={4}>
          <form>
            <InputController control={control} name="title" label="Tên cài đặt thông báo" isRequired styleContainer={{ pt: '4' }} />
            <InputController
              control={control}
              type="textarea"
              name="content"
              label="Nội dung cài đặt thông báo"
              isRequired
              styleContainer={{ pt: '4' }}
            />
            <SelectController
              label="Loại thông báo"
              name="type"
              placeholder="Chọn loại thông báo"
              control={control}
              options={SystemNotiOptions}
              isRequired
              styleContainer={{ pt: '4' }}
            />
            {/* <SelectController
              label="Chỉ định hội viên"
              name="listMembers"
              placeholder="Chọn hội viên"
              control={control}
              options={memberOptions}
              styleContainer={{ pt: '4' }}
              isMulti
            /> */}
            <AsyncSelectController
              styleContainer={{ pt: '4' }}
              styleBoxInput={{ flexShrink: '1', flexGrow: '1', flexBasis: '0' }}
              control={control}
              options={memberOptions}
              label="Chỉ định hội viên"
              name="listMembers"
              placeholder="Chọn hội viên"
              isMulti
              isLoading={isMemberLoading}
              onChange={valueSelected => {
                if (isEmpty(valueSelected)) {
                  setMemberFilter(InitMemberFilter);
                  fetchMemberData(InitMemberFilter, true);
                }
              }}
              onInputChange={onInputChange}
              loadOptions={loadOptions}
              handleOnScrollBottom={handleOnScrollBottom}
            />
            <FormControl pt={4}>
              <FormLabel minW="150px">Ảnh</FormLabel>
              <Box
                {...getRootProps()}
                cursor="pointer"
                borderWidth="1px"
                borderStyle="dashed"
                borderRadius="12px"
                padding="55px"
                textAlign="center"
                height="210px"
                display="flex"
                flexDirection="column"
                alignItems="center"
              >
                <input {...getInputProps()} />
                <BsUpload size={40} />
                {isDragEnter ? (
                  <p>Thả ảnh của bạn</p>
                ) : (
                  <>
                    <p>
                      <Text as="span" color="red.400">
                        Tải tập tin lên
                      </Text>
                      &nbsp;hoặc kéo và thả
                    </p>
                  </>
                )}
              </Box>
              <Grid templateColumns="repeat(5, 1fr)" gap={6} pt={5}>
                {files?.map((file, index) => (
                  <GridItem w={'100%'} key={file?.id} position="relative">
                    {typeof file === 'string' ? (
                      <Image src={ROOT_API + '/' + file} w="full" h="full" objectFit="contain" />
                    ) : (
                      <Image src={file?.preview} w="full" h="full" objectFit="contain" />
                    )}
                    {!file ? null : (
                      <IconButton bg="transparent" position="absolute" top="0" right="0" onClick={() => onRemove(index)}>
                        <BsXCircle size={16} color="red" />
                      </IconButton>
                    )}
                  </GridItem>
                ))}
              </Grid>
              {!!error.thumbnailFile && (
                <Text pt={1} color={'red.500'} fontSize="13px">
                  {error.thumbnailFile}
                </Text>
              )}
            </FormControl>
          </form>
          <Flex pt={6} alignItems="flex-end" justifyContent="flex-end">
            <Button
              onClick={() => {
                history.goBack();
              }}
            >
              Hủy
            </Button>
            <Button
              colorScheme="blue"
              ml={3}
              isDisabled={notiDetail?.data?.isPublished}
              isLoading={createSystemNotificationSetting.isPending}
              onClick={handleSubmit(onSubmit)}
              // onClick={onSubmit}
            >
              {!!_id ? 'Cập nhật ' : 'Tạo'}
            </Button>
          </Flex>
        </CardBody>
      </Card>
    </Flex>
  );
}
